export default {
  baseURL: 'https://banhammer.ai:1337'
}
